<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button>
<div class="container">
    <h1>Confirm!</h1>
    <h2>Are you sure you want to cancel refund?</h2>
    <div class="buttonRow">
        <button mat-raised-button type="button" class="button" (click)="onNoClick()" (click)="onClick()">
            Yes</button>
        <button mat-raised-button class="buttonReset" color="basic" type="button" (click)="onNoClick()"
            style="margin-left: 10px;">No</button>
    </div>
</div>
<alert></alert>
<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>